import { TableLoader } from 'nxui/src/components/loader/table/table.component'
import { Basic } from './basic'
import { Skeleton } from './skeleton'

export const Loader = {
    Basic,
    Skeleton,
    Table: TableLoader
}
